/**
 * 原始写法:
 * <script async src="https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID"></script>
 * <script>
 * window.dataLayer = window.dataLayer || [];
 * function gtag(){dataLayer.push(arguments);}
 * gtag('js', new Date());
 * gtag('config', 'GA_MEASUREMENT_ID');
 * </script>
 * gtag('config', 'GA_MEASUREMENT_ID', { 'send_page_view': false });
 * 
 */

import { config } from 'CONFIG';

class GA {

    /**
     * Creates an instance of GA.
     * @param {*} config 配置
     * @memberof GA
     */
    constructor ( config ) {

        this.client = config.client;
        this.init();
        
    }
    
    /**
     * 初始化 gtag 函数
     *
     * @returns void
     * @memberof GA
     */
    init () {
        
        this.bindEvent();
        this.gtag = config.featrue.disabled.includes( 'cloud.gtag' );

    }

    /**
     * 更新当前页面信息
     *
     * @param {*} pageName 页面名称
     * @param {*} newPath 页面path
     * @memberof GA
     */
    updateLocation ( pageName, newPath ) {

        if ( this.gtag ) {

            return;

        }
        this.href = newPath;
        window.gtag( 'config', this.accountId, {
            'page_title': pageName,
            'page_path': newPath,
            // page_location 的含义在这里是平台名称，可能有三种值： IOS/Android/Web
            'page_location': this.client
        });
    
    };

    /**
     * 发送包含client和path的pageview事件
     *
     * @param {*} client
     * @param {*} newPath
     * @memberof GA
     */
    pageview () {

        if ( this.gtag ) {

            return;
            
        }
        window.gtag( 'event', 'pageView', {
            'event_category': this.client,
            'event_label': this.href
        });
    
    };

    sendEvent ( type, category ) {

        if ( this.gtag ) {

            return;
            
        }
        try {
            
            window.gtag( 'event', `${type}(in ${this.client})`, {
                'event_category': category,
                'event_label': this.href
            });

        } catch ( err ) {

            console.error( err );

        }

    }

    sendSubscribeMode () {

        if ( !this.subscribeMode ) {

            return false;

        }
        let label = this.nextPlan;
        if ( this.subscribeMode === 'switch' ) {

            label = `${this.prevPlan} to ${label}`;

        }
        this.sendEvent( this.subscribeMode, label );

    }

    bindEvent () {

        const _this = this;
        $( 'body' ).on( 'click', '[ga-label]', e => {

            const label = $( e.target ).attr( 'ga-label' );
            _this.sendEvent( 'click', label );

        });

    }

}

export default new GA(
    {
        client: config.client
    }
);



// WEBPACK FOOTER //
// ./src/common/js/gtagPageview.js